import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseCompatibilityService {
  async getConnectionsByUserId(userId) {
    const ref = collection(db, 'compatibility')
    const q = query(ref, where('userId', '==', userId), orderBy('createdAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }
}
